module.exports = __webpack_public_path__ + "static/media/ImportIcon.de06e8ab.svg";